"use client";

import { type ReactNode } from "react";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

interface TrackingLinkProps {
  href: string;
  eventLabel: string;
  className?: string;
  children: ReactNode;
}

/**
 * A client-side <a> wrapper that fires a gtag conversion event on click.
 * Use this in server components where you need click-tracking on links.
 */
export default function TrackingLink({ href, eventLabel, className, children }: TrackingLinkProps) {
  return (
    <a
      href={href}
      onClick={() => {
        if (typeof window !== "undefined" && window.gtag) {
          window.gtag("event", "cta_clicked", {
            event_category: "conversion",
            event_label: eventLabel,
          });
        }
      }}
      className={className}
    >
      {children}
    </a>
  );
}
